import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper";
import { FaQuoteRight } from "react-icons/fa";

import Container from "../components/Container";
import 'swiper/css';
import 'swiper/css/navigation';
import { ScrollFadeIn } from "../../../components/ScrollFadeIn";

const goldStar =
    "https://res.cloudinary.com/abundo-wealth-assets/image/upload/v1658158536/Abundo%20Wealth%20Assets/pages/public-home/gold_star_bk4fzs.svg";



const testimonials = [
    
    {
        review: "Abundo changed the way I understood and managed my finances, in a very significant way. This team is down to earth, brilliant in what they do, very accessible and a game changer in this industry.   HIGHLY recommend.",

        name: 'Molly J.',
    }, 
      
       
         

           
            // More testimonials...
      
            {
                review: "If you want personal attention from people who actually care about you and your finances, and who care about charging a reasonable rate for the work they do, then there’s no reason to look elsewhere!",
               
                    name: 'Aubrey J.',
    },
    {
        name: "Luke H.",
        review:
            "Very happy I chose Abundo as our financial advisor. Their fees are fair, easy to understand and transparent. They embrace technology and everything is integrated and easy to use. Looking forward to working with long term.",
    },

            // More testimonials...
       
]
const oldTestimonials = [
    {
        name: "Molly J.",
        review:
            "Abundo changed the way I understood and managed my finances, in a very significant way. I had been with many of the big shops and had to put so much trust in them (and $) because I was confused with the guidance and direction they provided.  Eric and his team break things down to a point that you really feel in charge of your finances and future.  But they also set tough (and achievable) goals that keep you on track. This team is down to earth, brilliant in what they do, very accessible and a game changer in this industry.   HIGHLY recommend",
        rating: 5,
    },
    {
        name: "Josh N.",
        review:
            "Eric and the rest of the Abundo team are amazing. By taking a holistic look at our finances they helped us shift our planning from the standard advice everyone gives to a plan that will help us achieve our personal goals. They are also incredibly responsive no matter the question.",
        rating: 5,
    },
    {
        name: "Aubrey J.",
        review:
            "To borrow a phrase, Abundo is “simply the best”! If you want personal attention from people who actually care about you and your finances, and who care about charging a reasonable rate for the work they do, then there’s no reason to look elsewhere! Their subscription system is far more affordable than the percentage method that so many large banks/financial planners use. Call off the search, you’ve found what you’re looking for!",
        rating: 5,
    },
    {
        name: "Luke H.",
        review:
            "Very happy I chose Abundo as our financial advisor. Their fees are fair, easy to understand and transparent. They embrace technology and everything is integrated and easy to use. Looking forward to working with long term.",
        rating: 5,
    },
    {
        name: "Joey T.",
        review:
            "Abundo crushes it!!! If you are using any other company for your financial advice you definitely need to chat with the Abundo crew ASAP!! Number one, they are turning the financial services industry upside down! Number two, they have fair and transparent fees unlike other advisors that charge you on a percentage of your assets which is NOT cool. the bottom line is that Abundo totally cares about their clients and are a true fiduciary at a fair fee! Do yourself a favor and reach out to them ASAP to learn more!",
        rating: 5,
    },
    {
        name: "Linnea F.",
        review:
            "I want to thank the Abundo team for always taking the time to answer all of my financial questions. Their expertise, attention to detail, transparency, patience, and prompt response time is greatly appreciated! I feel so lucky to have found them!",
        rating: 5,
    },
    {
        name: "Josh H.",
        review:
            "The best people for the job!  No questions asked Abundo is the way to go. Personal and professional! Eric and his team are awesome!",
        rating: 5,
    },
];

export default function Testimonials() {
    return (
        <Container bgColor="bg-primary-800">
            <ScrollFadeIn>
                <div className="hidden sm:block">
                    <Swiper
                        navigation={true}
                        modules={[Navigation, Pagination, Autoplay]}
                        pagination={true}
                        className="text-white flex items-center justify-center"
                        slidesPerView={1}
                    >
                        {testimonials.map((item, index) => (
                            <div key={index}>
                                <SwiperSlide spacebetween={50} className="px-12 lg:px-20 xl:px-24 rounded-xl">
                                    <div className="space-y-5 xl:space-y-7 flex flex-col items-center">
                                        <div className="mx-auto">
                                            <div className="flex justify-center">
                                                <FaQuoteRight className="h-10 xl:h-16 w-10 xl:w-16 text-white" />
                                            </div>
                                        </div>
                                        <blockquote className="heading-2 text-center max-w-5xl mx-auto">{item.review}</blockquote>
                                        <cite className="heading-3 text-center mx-auto">{item.name}</cite>
                                    </div>
                                </SwiperSlide>
                            </div>
                        ))}
                    </Swiper>
                </div>

                <div className="sm:hidden">
                    <Swiper
                        navigation={false}
                        modules={[Navigation, Pagination, Autoplay]}
                        pagination={true}
                        className="text-white flex items-center justify-center"
                        slidesPerView={1}
                    >
                        {testimonials.map((item, index) => (
                            <div key={index}>
                                <SwiperSlide spacebetween={50}>
                                    <div className="space-y-7 flex flex-col items-center">
                                        <div className="mx-auto">
                                            <div className="flex justify-center">
                                                <FaQuoteRight className="h-10 sm:h-16 w-10 sm:w-16 text-white" />
                                            </div>
                                        </div>
                                        <blockquote className="heading-2 text-center max-w-5xl mx-auto">{item.review}</blockquote>
                                        <cite className="heading-3 text-center mx-auto">{item.name}</cite>
                                    </div>
                                </SwiperSlide>
                            </div>
                        ))}
                    </Swiper>
                </div>
                <div className="flex justify-center">
                    <p className="text-gray-300 text-xs text-center mt-10 max-w-2xl">
                        These testimonials were provided by current Abundo Wealth clients
                        and may not be representative of the experiences of other clients.
                        The clients were not compensated, nor are there material conflicts
                        of interest that would affect the given testimonials. You can view a
                        complete list of all Abundo Wealth reviews on our{" "}
                        <a
                            href="https://wealthtender.com/advisory-firms/abundo-wealth/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="underline"
                        >
                            Wealthtender profile page.
                        </a>
                    </p>
                </div>
            </ScrollFadeIn>
        </Container>
    )
}
